import React from 'react';
import ModalFormUI from '../../../widgets/form/ModalFormUI';
import InputTextSF from '../../../widgets/form/InputTextSF';
import InputSelectSF from '../../../widgets/form/InputSelectSF';

const SalesTargetCreateModalUI = ({
    // Modes
    context, successMsg, errorList, setErrorList, submitted,
    createMode,
    // Event Handlers
    onSubmit, onCancelClick,
    // Targets
    userId, onUserIdChange, userIdError, setUserIdError, userIdList,
    month, onMonthChange, monthError, setMonthError, monthList,
    year, onYearChange, yearError, setYearError, yearList,
    // Channel
    channel, onChannelChange, channelError, setChannelError, salesChannelList,
    noOfContacts, onNoOfContactsChange, noOfContactsError, setNoOfContactsError,
    newLeadTarget, onNewLeadTargetChange, newLeadTargetError, setNewLeadTargetError,
    newDisbTarget, onNewDisbTargetChange, newDisbTargetError, setNewDisbTargetError,
    numberOfCustomers, onNumberOfCustomersChange, numberOfCustomersError, setNumberOfCustomersError,
    contactsAchieved, onContactsAchievedChange, contactsAchievedError, setContactsAchievedError,
    newLeadAchieved, onNewLeadAchievedChange, newLeadAchievedError, setNewLeadAchievedError,
    newDisbAchieved, onNewDisbAchievedChange, newDisbAchievedError, setNewDisbAchievedError,
    customersAchieved, onCustomersAchievedChange, customersAchievedError, setCustomersAchievedError,

}) => {

    return (
        <ModalFormUI
            context={context}
            titleLabel='Create Sales Target'
            buttonLabel="Create"
            cancelLabel="Cancel"
            isOpen={createMode}
            onRequestClose={onCancelClick}
            successMsg={successMsg}
            errorList={errorList}
            setErrorList={setErrorList}
            onSubmit={onSubmit}
            busy={submitted}
        >
            <div className='g_flex_h g_flex_top'>
                <div className='cols g_m_right_100'>
            <InputSelectSF type="text" name="userId" label="User Id"
                maxLength={40} required={true} value={userId} optionList={userIdList}
                onChange={onUserIdChange} error={userIdError} setError={setUserIdError}
            />
            <InputSelectSF type="text" name="year" label="Year"
                maxLength={4} required={true} value={year} optionList={yearList}
                onChange={onYearChange} error={yearError} setError={setYearError}
            />
            <InputSelectSF type="text" name="month" label="Month"
                maxLength={20} required={true} value={month} optionList={monthList}
                onChange={onMonthChange} error={monthError} setError={setMonthError}
            />
            <InputSelectSF type='select' name='channel' required={true}
                label='Sales channel' autoFocus={true} optionList={salesChannelList}
                value={channel} onChange={onChannelChange}
                error={channelError} setError={setChannelError}
            />

            </div>
            <div className='cols g_m_right_100'>
            
            <InputTextSF type="text" name="noOfContacts" label="Number of Contacts"
                maxLength={40} required={true} value={noOfContacts}
                onChange={onNoOfContactsChange} error={noOfContactsError} setError={setNoOfContactsError}
            />
            <InputTextSF type="text" name="newLeadTarget" label="New Lead Target"
                maxLength={40} required={true} value={newLeadTarget}
                onChange={onNewLeadTargetChange} error={newLeadTargetError} setError={setNewLeadTargetError}
            />

            <InputTextSF type="text" name="newDisbTarget"
                label="New Disbursement Target" maxLength={40} required={true}
                value={newDisbTarget} onChange={onNewDisbTargetChange} error={newDisbTargetError} setError={setNewDisbTargetError}
            />

            <InputTextSF type="text" name="numberOfCustomers"
                label="Number of Customers" maxLength={40} required={true} value={numberOfCustomers}
                onChange={onNumberOfCustomersChange} error={numberOfCustomersError} setError={setNumberOfCustomersError}
            />
              </div>
              <div className='cols g_m_right_100'>

                <InputTextSF type="text" name="contactsAchieved" label="Contacts Achieved"
                    maxLength={40} required={true} value={contactsAchieved}
                    onChange={onContactsAchievedChange} error={contactsAchievedError} setError={setContactsAchievedError}
                />
                <InputTextSF type="text" name="newLeadAchieved" label="New Lead Achieved"
                    maxLength={40} required={true} value={newLeadAchieved}
                    onChange={onNewLeadAchievedChange} error={newLeadAchievedError} setError={setNewLeadAchievedError}
                />
                <InputTextSF type="text" name="newDisbAchieved" label="New Disbursement Achieved"
                    maxLength={40} required={true} value={newDisbAchieved}
                    onChange={onNewDisbAchievedChange} error={newDisbAchievedError} setError={setNewDisbAchievedError}
                />
                <InputTextSF type="text" name="customersAchieved" label="Customers Achieved"
                    maxLength={40} required={true} value={customersAchieved}
                    onChange={onCustomersAchievedChange} error={customersAchievedError} setError={setCustomersAchievedError}
                />
            </div>

            </div>
        </ModalFormUI>
    );
};

export default SalesTargetCreateModalUI;
